import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { checkIn, checkInWithPriority } from 'redux/slices';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';

export function CheckInPlayer({ playerId }) {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const handleCheckInNow = () => {
    dispatch(checkIn(playerId));
    setOpen(false);
  };

  const handleCheckInNext = () => {
    dispatch(checkInWithPriority(playerId));
    setOpen(false);
  };

  return (
    <>
      <Button variant="outlined" onClick={() => setOpen(true)}>Check-in</Button>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <DialogTitle>Fazer check-in de jogador</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Escolha a opção de check-in:
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Cancelar
          </Button>
          <Button
            variant="contained"
            onClick={handleCheckInNow}
          >
            Check-in agora
          </Button>
          <Button
            variant="contained"
            onClick={handleCheckInNext}
            color="secondary"
          >
            próxima
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
